import React from "react";
import { Button, Column, Heading, Modal, Row } from "@hex-insights/core";
import { useActivePageRegistration } from "@hex-insights/router";
import { Icon, MessageGroupComponents, Tile, User, UserGroup } from "@s-i-s-i/see-learning.shared";
import { NewMessageModal } from "../Components";
import { messagingCreatePageInfo } from "./pageinfo";
import styles from "./styles.module.css";

export function MessagingCreatePage() {
	useActivePageRegistration(messagingCreatePageInfo);

	const { isModalOpen, openModal, closeModal: baseCloseModal } = Modal.useToggle();

	const [initialUserID, setInitialUserID] = React.useState<User["id"] | null>(null);
	const onClickUserRecipient = React.useCallback(
		(id: User["id"]) => {
			setInitialUserID(id);
			openModal();
		},
		[openModal],
	);
	const initialUserIDs = React.useMemo(() => (initialUserID ? [initialUserID] : []), [initialUserID]);

	const [initialUserGroupID, setInitialUserGroupID] = React.useState<UserGroup["id"] | null>(null);
	const onClickUserGroupRecipient = React.useCallback(
		(id: UserGroup["id"]) => {
			setInitialUserGroupID(id);
			openModal();
		},
		[openModal],
	);
	const initialUserGroupIDs = React.useMemo(
		() => (initialUserGroupID ? [initialUserGroupID] : []),
		[initialUserGroupID],
	);

	const closeModal = React.useCallback(() => {
		baseCloseModal();
		setInitialUserID(null);
		setInitialUserGroupID(null);
	}, [baseCloseModal]);

	return (
		<Column justify="spaced-start" verticalSpacing="1.5rem" className={styles["index-page"]}>
			<div className={styles["header-row"]}>
				<div style={{ width: "11.44rem" }}></div>

				<Heading.H1 noMargin>Start a New Chat</Heading.H1>

				<Button variant="primary" onClick={openModal}>
					<Row justify="spaced-start" align="center" horizontalSpacing="0.5rem">
						<Icon.Users size={16} />
						New Group Message
					</Row>
				</Button>
			</div>

			<Tile style={{ minHeight: "37rem" }}>
				<Tile.Header>
					<Heading.H3 noMargin style={{ textAlign: "center" }}>
						Select who you'd like to message
					</Heading.H3>
				</Tile.Header>
				<Tile.Body style={{ display: "flex", flexDirection: "column" }}>
					<MessageGroupComponents.Create.InternalPortal.MessageRecipientSections
						onClickUserRecipient={onClickUserRecipient}
						onClickUserGroupRecipient={onClickUserGroupRecipient}
						style={{ flexGrow: 1 }}
					/>
				</Tile.Body>
			</Tile>

			<Modal.If condition={isModalOpen}>
				<NewMessageModal
					initialUserRecipientIDs={initialUserIDs}
					initialUserGroupRecipientIDs={initialUserGroupIDs}
					onClose={closeModal}
				/>
			</Modal.If>
		</Column>
	);
}
